<template>
  <div class="wrapper container">
    <div class="content">
      <h2 class="title">极客邦服务使用协议</h2>
      <p class="time">生效日期：2019年9月9日</p>

      <div class="one item">
        <h4 class="subtitle">第一条【重要提示】</h4>
        <p class="sentence">请您（以下亦称“用户”）在申请注册流程或者使用本公司产品时，<span class="strong">点击同意本协议之前，仔细阅读本协议之全部条款，并确认您已完全理解本协议之规定，尤其是免除及限制责任的条款、知识产权条款、法律适用及争议解决条款。</span>除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束，本协议将构成您与北京极客邦科技有限公司（北京极客邦科技有限公司（及关联方）与其主办的网站、App、微信小程序合称为“极客邦”）之间直接有约束力的法律文件。如您对协议有任何疑问，请立即停止注册或使用极客邦提供的服务，并可向极客邦客服咨询。</p>
      </div>

      <div class="two item">
        <h4 class="subtitle">第二条【协议的变更】</h4>
        <p class="sentence strong">1.北京极客邦科技有限公司有权利对本协议进行修改，协议修改后，极客邦控股将在相关页面公布修改的内容，修改后的协议一经公布即代替原协议。如果您不同意本协议的修改，请立即停止访问或使用“极客邦”提供的产品或取消已经获得的服务；如果您选择在本协议修改后继续访问或使用“极客邦”，则视为完全接受并愿意遵守修改或者变更后的本协议。</p>
        <p class="sentence">2.您与极客邦公司签署的本协议所列明的条款，并不能完全涵盖您与极客邦公司所有的权利和义务。因此，<span class="strong">极客邦公司公布其他声明、规则等均视为本协议之补充协议，为本协议不可分割的组成部分，与本协议具有同等法律效力。</span></p>
      </div>

      <div class="three item">
        <h4 class="subtitle">第三条【服务的内容与方式】</h4>
        <p class="sentence">1.“极客邦”主要是一家网络服务提供者，可针对不同用户为其提供内容服务，包括但不限于付费专栏、在线教育、学员管理、电子商务等；由于互联网的高速发展，极客邦公司将在未来向用户提供更多的服务，除非另有明确规定外，未来提供的新服务也适用于本协议。</p>
        <p class="sentence">2.除免费服务外，“极客邦”可能提供部分收费服务。您可以通过付费方式购买收费服务，具体方式为：通过网上银行或其他“极客邦”提供的付费途径支付一定数额的人民币，从而获得收费服务使用权限。<span class="ston">对于收费服务，“极客邦”会在您使用之前给予明确的提示，只有根据提示确认其同意按照前述支付方式支付费用并完成了支付行为，才能使用该等收费服务。支付行为的完成以银行或第三方支付平台生成“支付已完成”的确认通知为准。</span></p>
        <p class="sentence">3.您应了解“极客邦”作为平台，不保证其提供的服务一定满足用户的全部需求。“极客邦”保留随时修改、中断或终止无偿服务且无需通知用户的权利。若影响您与极客邦进行的有偿交易，您同意极客邦有权在事先通知的情况下予以修改、中断，双方将按照公平公正、诚实信用、等价有偿的原则处理后续事宜。“极客邦”更改、更新或提高其服务无需对用户或任意第三方承担任何责任。</p>
      </div>

      <div class="four item">
        <h4 class="subtitle">第四条【注册账号与使用】</h4>
        <p class="sentence">1.您确认，在您开始注册 “极客邦”账户前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</p>
        <p class="sentence">2.您有权选择是否成为“极客邦”的注册用户。</p>
        <p class="sentence">（1）您选择注册账号成为“极客邦”的用户时，应按照“极客邦”的提示及要求填写或提供资料、信息，并确保资料、信息的真实性、正确性及完整性。如果您的资料、信息发生变化，应及时更改。</p>
        <p class="sentence">（2）您注册账号时承诺：不得冒用他人信息注册账号；不得使用色情、暴力或者违反公序良俗的词汇、图片注册账号。否则“极客邦”有权随时限制、拒绝您使用该账号，或者注销该账号。</p>
        <p class="sentence">（3）当您一旦注册成功，即成为“极客邦”的注册用户。成为“极客邦”的注册用户后，您可依照“极客邦”的要求修改您的账号密码，但不可修改账号。头像、用户名和昵称的命名及使用应遵守相关法律法规并符合网络道德。头像、用户名和昵称中不能含有任何侮辱、诽谤、淫秽或暴力等侵害他人合法权益或违反公序良俗的词语或内容。如您违反前述规定，“极客邦”有权随时限制或拒绝您使用该账号，甚至注销该账号。</p>
        <p class="sentence">（4）用户注册成功时，您将创建一个账号和密码。您应采取合理措施维护账号和密码的安全，您应了解，在账号和密码匹配时，“极客邦”无法对非法或未经您授权使用您帐号及密码的行为作出甄别，因此，“极客邦”对任何使用您账号和密码登录系统后所发生的所有活动和事件不承担任何责任。</p>
        <p class="sentence">3.用户的账号或密码遗失，可以通过注册信息进行重置密码，以手机号码注册的用户可以凭借手机号码找回原密码。用户若发现账号遭到未授权的使用或发生其他任何安全问题时，应立即有效告知“极客邦”。<span class="strong">“极客邦”有权根据自己的判定，在怀疑账号被不当使用时，拒绝或限制账号使用，或注销该账号，同时终止本协议。</span></p>
        <p class="sentence">4.您有权注销您的账户，当您需要注销账户时，请您联系平台客服帮您处理。<span class="strong">请您知悉，您的账户一旦被注销后将造成您无法继续收听您已购买的付费内容或上传内容等，您同意一切后果由您自行承担。</span></p>
      </div>

      <div class="five item">
        <h4 class="subtitle">第五条【用户的权利与义务】</h4>
        <p class="sentence">1.用户有权在注册后获得其个人的“极客邦”账号；</p>
        <p class="sentence">2.用户有权在注册并登录后，根据“极客邦”的规定，参与“极客邦”的线上或线下活动并取得“极客邦”给予的优惠或者奖励等；</p>
        <p class="sentence">3.用户有权在注册并登录后，根据“极客邦”的规定，参与“极客邦”的商业性项目，通过“极客邦”提供的增值化服务取得经济收益。</p>
        <p class="sentence">4.用户承诺并保证遵守《中华人民共和国著作权法》《中华人民共和国商标法》《中华人民共和国反不正当竞争法》《中华人民共和国侵权责任法》《中华人民共和国广告法》《中华人民共和国网络安全法》《中华人民共和国计算机信息系统安全保护条例》《计算机软件保护条例》及《信息网络传播权保护条例》等有关法律、法规、规章的规定。在任何情况下，“极客邦”合理的认为用户有可能违反上述法律、法规、规章的规定，有权不经事先通知终止向该用户提供服务。</p>
        <p class="sentence">5.用户应当善意使用极客邦且保证：</p>
        <p class="sentence">（1）不会伪造标题或以其他方式操控识别资料，使人误认为该内容为“极客邦”所传送的。</p>
        <p class="sentence">（2）不会将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上传、张贴、发送电子邮件或以其他方式传送。</p>
        <p class="sentence">（3）不会以技术方式攻击或破坏或改变“极客邦”的部分或全部、或干扰其运行；以非法方式获取或使用“极客邦”的任何软件、代码或其他技术或商业信息；不会对“极客邦”运行的任何程序进行反向工程、反向编译、反向汇编或改写。</p>
        <p class="sentence">（4）不会未经许可使用“极客邦”的网站名称、公司名称、商标、商业标识、网页版式或内容、或其他由“极客邦”享有知识产权或权利的信息或资料；</p>
        <p class="sentence">（5）在平台上传的文字、图片、视频、音频、多媒体资料或其他内容不侵犯任何第三方的肖像权、名誉权、著作权、商标权等权利；不违反用户与第三方所签订的对用户有约束力的法律文件的规定；否则，“极客邦”有权对用户发布的信息依法或依据本协议进行删除或屏蔽，并有权不经事先通知终止向该用户提供服务。</p>
        <p class="sentence">6.未经“极客邦”书面许可、另行签署协议或另行指定可供用户使用的特定商业服务外，用户不得以商业目的使用“极客邦”；也不得以任何形式将“极客邦”作为从事商业活动的场所、平台或媒介。</p>
        <p class="sentence">7.未经“极客邦”书面许可、另行签署协议或另行指定可供用户使用的特定商业服务外，用户不得通过“极客邦”发布有关任意第三方的广告宣传内容。</p>
        <p class="sentence">8.用户就其所上传的内容承担全部法律责任。因用户违反法律规定或本协议规定造成违约或侵犯第三方合法权益的，由用户自行解决。如果给“极客邦”造成损失，“极客邦”有权向用户追偿其因此所遭受的全部损失，包括其直接损失、间接损失、预期利益损失等损失。</p>
      </div>

      <div class="six item">
        <h4 class="subtitle">第六条【用户个人信息保护】</h4>
        <p class="sentence strong">1.用户注册并获得“极客邦”提供的服务时，“极客邦”可能需要收集能识别用户身份的个人信息以便可以在必要时联系用户或提供相应的服务。为了向用户提供更好的使用体验，在征得用户的同意后收集用户的个人信息。“个人信息”包括但不限于用户的姓名、性别、年龄、出生日期、联系电话、身份证号、地址、受教育情况、公司情况、所属行业、兴趣爱好、手机软硬件信、手机识别码等。</p>
        <p class="sentence">2.“极客邦”承诺，未经用户同意，不会以非法方式披露应予保密的用户个人信息。但是下列情形除外：依照法律或司法、行政机关的强制性命令对第三方披露用户个人信息且无需事先向用户发出通知。</p>
        <p class="sentence strong">3.“极客邦”承诺，将遵循法律、法规的规定及合法、正当、必要的原则收集和使用您的个人信息。您同意“极客邦”按照《极客邦个人信息保护指引》对您的个人信息进行收集、存储、使用、管理、传输、披露、保护和处理。具体条款详见《极客邦个人信息保护指引》。</p>
      </div>

      <div class="seven item">
        <h4 class="subtitle">第七条【用户发布的信息或内容】</h4>
        <p class="sentence strong">1.您在“极客邦”平台以各种形式发布的一切信息或内容，均应符合国家法律法规等相关规定及平台相关规定，符合社会公序良俗，并且不侵犯任何第三方主体的合法权益。“极客邦”有权随时检查您所发布的内容，如果发现您发布的内容不符合前述规定，“极客邦”有权删除或隐藏您所发布的内容、追究您的法律责任并根据相关法律法规向监管机关、司法机关报告。</p>
        <p class="sentence">2.“极客邦”有权对您发布的信息或内容进行检查、编辑。但是对于通过平台而传播的信息或内容，“极客邦”不保证其合法性、正当性、准确性或完整性。<span class="strong">在任何情况下，“极客邦”均不对任何第三方用户发布的信息或内容承担任何责任，包括但不限于由于任何信息或内容而导致直接或间接损失。</span>用户应自行承担因此产生的一切法律后果，且“极客邦”因此受到的损失，有权向用户追偿。</p>
        <p class="sentence strong">3.平台将尽可能保存您发布的合法信息或内容，但不承诺将为您保存其发布的信息或内容，您应自行就前述内容备份。</p>
        <p class="sentence">4.您应当确保您在平台发布的信息或内容不会侵犯任何第三方的合法权益。如第三方提出异议，“极客邦”有权根据实际情况进行处理，包括但不限于隐藏、删除相关信息或内容，并追究您的法律责任。</p>
        <p class="sentence strong">5.您应当确保不发布、传播含有下列内容的信息：  </p>
        <p class="sentence strong">（1）反对宪法所确定的基本原则的；  </p>
        <p class="sentence strong">（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；  </p>
        <p class="sentence strong">（3）损害国家荣誉和利益的；  </p>
        <p class="sentence strong">（4）煽动民族仇恨、民族歧视，破坏民族团结的；  </p>
        <p class="sentence strong">（5）破坏国家宗教政策，宣扬邪教和封建迷信的；  </p>
        <p class="sentence strong">（6）散布谣言，扰乱社会秩序，破坏社会稳定的；  </p>
        <p class="sentence strong">（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；  </p>
        <p class="sentence strong">（8）侮辱或者诽谤他人，未经他人同意泄露他人隐私或个人信息，侵害他人合法权益的；</p>
        <p class="sentence strong">（9）侮辱、诽谤或者以其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉，歪曲、丑化、亵渎、否定英雄烈士事迹和精神的；</p>
        <p class="sentence strong">（10）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p>
        <p class="sentence strong">（11）违反国家有关规定，发布系统漏洞、计算机病毒、网络攻击、网络侵入等网络安全信息的；</p>
        <p class="sentence strong">（12）含有法律、行政法规禁止的其他内容。</p>
      </div>

      <div class="eight item">
        <h4 class="subtitle">第八条【知识产权】</h4>
        <p class="sentence">1.北京极客邦科技有限公司对极客邦网站、app服务及极客邦网站、app所使用的软件所包含的受知识产权法或其他法律保护的资料享有相应的权利，极客邦网站、app的整体内容版权（包括但不仅限于设计图样以及其他图样、产品及服务名称）归北京极客邦科技有限公司所有，任何人不得使用、复制或用作其他用途。</p>
        <p class="sentence">2.经由本网站传送的文字、图片、音频、视频及其他内容，受到著作权法、商标法、专利法或其他法律的保护；除该文字、图片、音频、视频及其他内容的上传用户所享有的著作权，未经北京极客邦科技有限公司书面授权许可，不得自行或许可第三方进行修改、出租、售卖或衍生其他作品。</p>
        <p class="sentence strong">3.“极客邦”对其专有内容、原创内容和其他通过授权取得的独占或者独家内容享有知识产权。未经“极客邦”书面许可，任何单位和个人不得私自转载、传播和提供收听服务或者有其他侵犯“极客邦”知识产权的行为。否则，将承担法律责任。用户有上述行为的，“极客邦”有权限制该用户的部分功能、冻结账号、注销账号。</p>
        <p class="sentence strong">4.除非“极客邦”收到相反通知，“极客邦”将用户视为其在“极客邦”上传或发布的内容的版权所有人。用户点击同意本协议，即表明该用户将在“极客邦”上发表的全部内容（包括但不仅限于留言、评论和笔记），授予“极客邦”免费的、不可撤销的、非独家使用许可，“极客邦”有权将该内容用于“极客邦”各种形态的产品和服务上，包括但不限于“极客邦”已经发表的应用或其他互联网产品。</p>
        <p class="sentence">5.用户在“极客邦”上传或发表的内容，应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，“极客邦”有权根据实际情况删除相关的内容，且有权追究用户的法律责任。给“极客邦”或任何第三方造成损失的，用户应负责全额赔偿。同时用户许可北京极客邦科技有限公司有权利就任何主体侵权而单独提起诉讼，并获得赔偿。本协议已经构成《著作权法》第二十五条所规定的书面协议，其效力及于用户在“极客邦”发布的任何受著作权法保护的内容，无论该内容形成于本协议签订前还是本协议签订后。</p>
      </div>

      <div class="nine item">
        <h4 class="subtitle">第九条【“极客邦”的商业活动】</h4>
        <p class="sentence">用户理解并接受，“极客邦”为维护其运营，可以进行下述商业活动：</p>
        <p class="sentence">1.通过电子邮件、客户端、网页或其他合法方式向用户发送推广信息或其他相关商业信息。</p>
        <p class="sentence">2.通过增值服务系统或其他方式向用户发送相关服务信息或其他信息，其他信息包括但不限于通知信息、宣传信息、广告信息等。</p>
      </div>

      <div class="ten item">
        <h4 class="subtitle">第十条【免责说明】</h4>
        <p class="sentence strong">1.“极客邦”作为网络服务提供者，不担保网站平台上的信息及服务能充分满足用户的需求。因法律、政策、技术、经济、管理的原因，除非您和“极客邦”另有约定，“极客邦”不会因以下情形出现而对您承担责任：</p>
        <p class="sentence strong">（1）“极客邦”无法使用或中断使用或无法完全适合用户的使用要求。</p>
        <p class="sentence strong">（2）“极客邦”受到干扰，无法及时、安全、可靠运行，或出现任何错误。</p>
        <p class="sentence strong">（3）经由“极客邦”取得的任何产品、服务（含收费服务）或其他材料不符合您的期望。</p>
        <p class="sentence strong">（4）用户资料遭到未经授权的使用或修改。</p>
        <p class="sentence strong">2.“极客邦”不对您在本协议项下服务中相关数据的删除或储存失败负责。“极客邦”可以根据实际情况自行决定用户在本服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。如您停止使用“极客邦”，或“极客邦”所提供的服务终止或中止，“极客邦”可以从服务器上永久地删除用户的数据。“极客邦”没有义务向用户返还任何数据。</p>
        <p class="sentence strong">3.用户在接受“极客邦”服务的过程中，可能遇到错误的、非法的、非道德的及存在其他失宜之处的信息及被错误归类或是带有欺骗性的发布内容，您通过“极客邦”发布的任何信息或内容以及通过“极客邦”平台传播的任何观点不代表“极客邦”的立场，您应当自行做出判断。在任何情况下，因前述非正当信息而导致的任何损失或伤害，应由相关行为主体承担全部责任。</p>
        <p class="sentence strong">4.您使用“极客邦”的服务及通过“极客邦”发布任何信息或者内容应当遵守国家法律、法规和相关规定，您使用“极客邦”的服务及通过“极客邦”发布任何信息或者内容产生的行为后果有您自行承担。</p>
      </div>

      <div class="eleven item">
        <h4 class="subtitle">第十一条【第三方链接】</h4>
        <p class="sentence">为方便您使用，“极客邦”可能会提供第三方国际互联网网站或资源链接，除非另有声明，“极客邦”无法对第三方网站服务进行控制，因此由于下载、传播、使用或依赖上述网站或资源产生的损失或损害，用户自行承担全部责任。</p>
      </div>

      <div class="twelve item">
        <h4 class="subtitle">第十二条【服务终止】</h4>
        <p class="sentence strong">1.本协议或本协议项下“极客邦”所提供的服务（含收费服务）可在下述情形下部分或全部中止或终止：</p>
        <p class="sentence strong">（1）因法律规定，或“极客邦”服从行政命令或司法判令的要求。</p>
        <p class="sentence strong">（2）用户违反本协议。</p>
        <p class="sentence strong">（3）您盗用他人账号、发布违禁信息、采取不正当手段牟利等行为；</p>
        <p class="sentence strong">（4）您侵犯“极客邦”或他人知识产权或其他合法权益。 </p>
        <p class="sentence strong">（5）您的账号被成功注销；</p>
        <p class="sentence strong">（6）“极客邦”认为应予终止的其他情形。</p>
        <p class="sentence">2.在一般情形下，“极客邦”会提前按照用户提供的联系方式以电子邮件或短信或其他电子方式通知用户，服务将中止或终止。用户应了解并同意，在紧急情况或特殊情况下，“极客邦”可不经通知即中止或终止服务。</p>
        <p class="sentence">3.在本协议或本协议项下“极客邦”提供的服务（含收费服务）中止或终止时，“极客邦”有权</p>
        <p class="sentence">（1）拒绝用户登录“极客邦”；</p>
        <p class="sentence">（2）删除用户信息；</p>
        <p class="sentence">（3）删除用户购买的内容。</p>
        <p class="sentence">4.用户同意，不因本协议或本协议项下“极客邦”所提供的服务中止或终止，而要求北京极客邦科技有限公司（及关联方）或“极客邦”向您作出赔偿或补偿或承担任何其他责任，但法律规定应由“极客邦”承担责任的除外。</p>
      </div>

      <div class="thirteen item">
        <h4 class="subtitle">第十三条 【侵权投诉】</h4>
        <p class="sentence">1.根据《中华人民共和国侵权责任法》的规定，任何第三方认为，用户利用“极客邦”侵害其民事权益或实施侵权行为的，被侵权人有权书面通知“极客邦”采取删除、屏蔽、断开链接等必要措施。</p>
        <p class="sentence">2.侵权投诉必须包含下述信息：被侵权人的有效权利证明材料，或被侵权作品的原始链接及其他证明材料；侵权信息或作品在“极客邦”上的具体名称及链接；侵权投诉人的联络方式，以便“极客邦”及时与您取得联系，包括电子邮件地址、电话号码或手机号码等；投诉内容须纳入以下声明：“本人本着诚信原则，有证据认为该对象侵害本人的合法权益。本人承诺全部投诉信息真实、准确，自愿承担一切后果。”；本人亲笔签字并注明日期，如代理他人投诉的，必须出具授权人签字的授权书。</p>
      </div>

      <div class="fourteen item">
        <h4 class="subtitle">第十四条【法律责任】</h4>
        <p class="sentence">1.用户就所上传的内容承担全部法律责任；无论前述责任是因侵犯第三方权利所引起的、或因用户违反与第三方或本协议引起的、或因用户违反法律引起的；前述责任包括对“极客邦”或第三方所承担的民事责任、或行政机关要求承担的行政责任或刑事责任。</p>
        <p class="sentence">2.如因用户违反法律规定或本协议规定给“极客邦”造成损失，用户应当充分赔偿“极客邦”所遭受的损失、包括其直接损失、间接损失、预期利益损失等一切损失。</p>
        <p class="sentence">3.用户承诺，如因第三方向用户主张权利而导致用户承担责任，或用户承担行政责任或刑事责任的，用户不以此为理由追究“极客邦”的责任。</p>
        <p class="sentence">4.如用户应向“极客邦”承担责任，前述责任不因本协议或本协议项下的服务被终止而免除。</p>
      </div>

      <div class="fifteen item">
        <h4 class="subtitle">第十五条【法律适用、管辖和其他】</h4>
        <p class="sentence">1.本协议的生效、履行、解释及争议的解决均适用中华人民共和国法律。用户因使用“极客邦”而产生或与之相关的一切争议、权利主张或其他事项，均适用中华人民共和国法律（不包括冲突法和港澳台法律及规定）。</p>
        <p class="sentence strong">2.因本协议引起的或与本协议有关的任何争议，均提请北京仲裁委员会按照其仲裁规则进行仲裁。仲裁地点为北京，仲裁语言为中文。仲裁裁决是终局的，对各方均有约束力。</p>
        <p class="sentence">3.“极客邦”可能不时发布针对用户的相关协议，并可能将该相关协议作为对本协议的补充或修改而将其内容作为本协议的一部分。请用户及时关注并阅读相关协议。</p>
        <p class="sentence">4.本协议任意一条被视为废止、无效或不可执行，该条款应视为可分的且不影响本协议其他条款的法律效力。</p>
      </div>

      <div class="appendix-one item">
        <h4 class="subtitle strong">附件一：《极客时间VIP年卡服务协议》</h4>
        <p class="sentence">极客时间VIP年卡服务协议（以下称“本协议”）适用极客时间VIP年卡服务（以下称“VIP年卡服务”或“本服务”），当您订购VIP年卡服务前，应当充分阅读本协议。您的订购行为将被视为对本协议的确认。本协议是《极客邦服务使用协议》的一部分，本协议与《极客邦服务使用协议》约定不一致的，以本协议为准，本协议未明确约定或未约定的事项，以《极客邦服务使用协议》为准。极客邦有权根据实际运营情况等原因对本协议进行修订，您的使用行为视为对本协议及其后续修订版本的确认和同意。</p>
        <p class="sentence">1.VIP年卡服务是极客邦基于极客时间专栏、视频课程、微课产品向您提供的，通过支付一定费用或领取资格在一定期限内享有上述产品权益的服务。您可以通过支付一定费用或领取资格开通极客时间VIP年卡服务。VIP年卡服务开通后，您可以在一年（365天）内，阅读和观看上述产品的内容。</p>
        <p class="sentence">2.VIP年卡服务的权益范围包括极客时间专栏、视频课程、微课及极客邦将来可能增加或调整的产品服务。VIP年卡服务权益范围不包括每日一课产品服务。极客邦有权根据实际运营情况、著作权授权等原因对VIP年卡服务的产品权益进行调整。</p>
        <p class="sentence">3.本服务仅供您个人使用，您在使用过程中不得与他人共享或分享服务权益。</p>
        <p class="sentence">4.本服务期限为一年（365天），服务期限届满，您所享有的服务权益将自动终止，您阅读或观看过的产品内容需重新购买本服务后才能重新阅读和观看。</p>
        <p class="sentence">5.除您从所在的公司、企业或其他组织领取使用资格外，本服务均应在极客时间平台内支付相应金额进行购买。</p>
        <p class="sentence">6.本服务为在线使用的数字化商品服务，一经购买成功，极客邦不提供退货退款。请您确认后购买。</p>
        <p class="sentence">7.极客邦有权对本服务相关规则和收费标准进行调整，上述调整一经发布即生效。但是收费标准调整不影响已经购买的用户使用，仅对调整后的用户购买或续费行为产生效力。</p>
        <p class="sentence">8.如您对本协议或相关事宜有任何问题，您可以随时通过联系客服与我们联系。</p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
@import "../../style/bulma/app.sass"
.content
  width: 775px
  margin: 0 auto
  margin-bottom: 40px
  font-family: PingFang SC
  +mobile
    width: 100%
  .strong
    font-weight: 600
  .title
    margin-top: 64px
    font-weight: bold
  .time
    text-align: right
  .item
    .subtitle
      font-weight: bold
      margin-top: 30px
      border-left: 3px solid $primary3
      padding-left: 10px
      margin-bottom: 18px
</style>
